// Maintain and distribute overarching organization filter data
;(function () {
  'use strict'
  angular.module('obex').factory('agencySelectService', ['$q', '$window', 'organizations', 'authService', 'obexRoles',
    function ($q, $window, organizations, authService, obexRoles) {
      const storage = $window.localStorage
      const selectedAgency = {}
      return {
        getSelectableAgencies() {
          const logInUser = authService.getLoginMember()
          return organizations.getAgencies().then(function (response) {
            const agencies = response.data
            const selectableAgencies = agencies
              .map(function (org) {
                return {
                  name: org.Name,
                  id: org.Id
                }
              })
              .sort(function (a, b) {
                return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)
              })
            
            return $q.when(selectableAgencies)
          })        
        },
        setSelectedAgency(id, name) {
          selectedAgency.id = id
          selectedAgency.name = name
          storage.setItem('selectedAgency', JSON.stringify(selectedAgency))
          console.log('selectedAgency set to', selectedAgency)
        },
        getSelectedAgency() {
          let sa = selectedAgency
          if (sa.id === undefined || sa.name === undefined) {
            if (storage.getItem('selectedAgency')) {
              sa = JSON.parse(storage.getItem('selectedAgency'))
            }
          }
          return sa
        },
        clearSelectedAgency() {
          selectedAgency.id = undefined
          selectedAgency.name = undefined
          storage.removeItem('selectedAgency')
          console.log('selectedAgency cleared')
        }
      }
    }])
})()



// WEBPACK FOOTER //
// ./client/js/services/agencySelect.service.js